import { observable } from 'mobx';
import Objednavka from 'src/models/Objednavka';
import WebObjednavka from 'src/models/WebObjednavka';
import { IApiService } from 'src/services/IApiService';
import Turnus from 'src/models/Turnus';
import NewOrderResponse from 'src/services/response/NewOrderResponse';
import PreparePaymentDetailsResponse from 'src/services/response/PreparePaymentDetailsResponse';
import Den from 'src/models/Den';
import SendPaymentDetailsResponse from 'src/services/response/SendPaymentDetailsResponse';
import CalculateOrderResponse from 'src/services/response/CalculateOrderResponse';
import Historie from 'src/models/Historie';
import NovaObjednavka from 'src/models/NovaObjednavka';

export default class ObjednavkaStore {
    @observable public objednavky: Objednavka[] = [];
    @observable public webObjednavky: WebObjednavka[] = [];

    public orderTemplate: NovaObjednavka;

    private api: IApiService;
    constructor(api: IApiService) {
        this.api = api;
    }

    public getObjednavkaByID(id: number): Objednavka {
        const result = this.objednavky.filter(a => {
          return a.id === id;
        });

        if (result.length > 0) {
            return result[0];
        } else {
            return null;
        }
    }

    public getWebObjednavkaByID(id: number): WebObjednavka {
        const result = this.webObjednavky.filter(a => {
          return a.id === id;
        });

        if (result.length > 0) {
            return result[0];
        } else {
            return null;
        }
    }

    public removeWebObjednavkaFromLocalStore(id: number) {
        const index = this.webObjednavky.findIndex(val => val.id === id)
        if(index !== -1) {
            this.webObjednavky.splice(index, 1)
        }
    }

    public removeObjednavkaFromLocalStore(id: number) {
        const index = this.objednavky.findIndex(val => val.id === id)
        if(index !== -1) {
            this.objednavky.splice(index, 1)
        }
    }

    public loadAll(): Promise<boolean> {
        return new Promise(resolve => {
            this.api.getWebObjednavky().then(objs => {
                objs.forEach(obj => {
                    this.webObjednavky.push(obj);
                });
                this.api.getObjednavky().then(a => {
                    a.forEach(item => this.objednavky.push(item));
                    resolve(true);
                });
            });
        })
    }

    public updateOrder(objednavka: Objednavka): Promise<Objednavka> {
        return this.api.updateOrder(objednavka);
    }

    public preparePaymentDetails(orderId: number): Promise<PreparePaymentDetailsResponse> {
        return this.api.preparePaymentDetails(orderId);
    }

    public createNewOrderObject(order: NovaObjednavka): Promise<NewOrderResponse> {
        return this.api.createNewOrder(order.turnusy, order.dny, order.slevy, order.eko, order.nekompletni, order.castecneMenu, order.webObjednavka);
    }

    public calculateNewOrderFull(order: NovaObjednavka): Promise<PreparePaymentDetailsResponse> {
        return this.api.calculateNewOrderFull(order.turnusy, order.dny, order.slevy, order.eko, order.nekompletni, order.castecneMenu, order.webObjednavka);
    }

    public sendPaymentDetails(orderId: number, emailAddress: string, emailText: string): Promise<SendPaymentDetailsResponse> {
        return this.api.sendPaymentDetails(orderId, emailAddress, emailText);
    }

    public calculateNewOrder(turnusy: Map<number, Turnus[]>, dny: Map<number, Den[]>): Promise<CalculateOrderResponse[]> {
        return this.api.calculateNewOrder(turnusy, dny);
    }

    public markWebOrderProcessed(id: number): Promise<boolean> {
        return this.api.markWebOrderProcessed(id).then(success => {
            const index = this.webObjednavky.findIndex(a => a.id === id);
            if(index >= 0) {
                this.webObjednavky.splice(index, 1);
            }
            return true;
        });
    }

    public deleteOrder(orderID: number): Promise<boolean> {
        return this.api.deleteOrder(orderID);
    }
}


// WEBPACK FOOTER //
// ./src/stores/ObjednavkaStore.tsx